import { FC, useContext, useState } from 'react';
import { UseModalContext, ModalContext } from '@prometheus/hooks';

import { getUUID } from '@prometheus/utils';
import { publishDataSource } from '@/api';

import { Route, Routes } from 'react-router-dom';
import { DatabaseEntity } from '../DatabaseEntity';

import { DatabasesList } from './DatabasesList';
import { PublishDataSourceForm } from '../PublishDataSourceForm';
import { useTranslation } from 'react-i18next';

export const Databases: FC<any> = ({ root }) => {
  const { openModal, closeModal } = useContext<UseModalContext>(ModalContext);
  const [isReload, setIsReload] = useState(getUUID());
  const { t } = useTranslation();
  const onPublish = (id: any) => {
    openModal(
      () => (
        <PublishDataSourceForm
          dataSourceId={id}
          onCancel={closeModal}
          createMethod={publishDataSource}
          onPublish={values => {
            setIsReload(getUUID());
            closeModal();
          }}
        />
      ),
      t('modals.publish_database_header'),
      {
        closeOnClickOutside: true,
        onClose: closeModal,
      }
    );
  };

  return (
    <>
      <Routes>
        <Route
          path="*"
          element={
            <DatabasesList
              onPublish={onPublish}
              root={root}
              isReload={isReload}
              setIsReload={setIsReload}
            />
          }
        />
        <Route
          path=":id/*"
          element={<DatabaseEntity onPublish={onPublish} root={root} />}
        />
      </Routes>
    </>
  );
};
